import { Bone } from '../primitives';

// Matches SavedProfiles.tsx's real rows: preview icon + name + trailing action icons
// (no thumbnail/duration/status columns like the content table).
export default function SavedProfilesSkeleton({ rows = 5 }) {
    return (
        <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, overflow: 'hidden' }}>
            {Array.from({ length: rows }).map((_, i) => (
                <div
                    key={i}
                    style={{
                        display: 'flex', alignItems: 'center', gap: 10, padding: '12px 16px',
                        borderBottom: i < rows - 1 ? '1px solid #F1F5F9' : 'none',
                    }}
                >
                    <Bone w={30} h={30} r={999} />
                    <Bone h={13} w="35%" />
                    <div style={{ flex: 1 }} />
                    <Bone w={20} h={20} r={5} />
                    <Bone w={20} h={20} r={5} />
                    <Bone w={20} h={20} r={5} />
                </div>
            ))}
        </div>
    );
}
